import styles from "./Designer.module.css";
import Stepper from "./Stepper";
import ExternalStepNav from "./ExternalStepNav";
import DesignerPreviewPanel from "./DesignerPreviewPanel";
import DesignerStepPanel from "./DesignerStepPanel";
import DesignerHeaderSection from "./DesignerHeaderSection";
import { STEP } from "./designerSteps";

const DesignerMainLayout = ({
    isPageVariant,
    variantError,
    onClose,
    steps,
    currentStep,
    currentStepKey,
    stripeColors,
    variantStepProps,
    detailsStepProps,
    stripesStepProps,
    isPreviewCollapsed,
    onTogglePreviewCollapsed,
    selectedPartsForPreview,
    normalizedRoot,
    viewSide,
    selectedPrints,
    printDetails,
    allColors,
    activePrintKey,
    onSelectPreviewPrint,
    onTransformPrint,
    onDeletePrint,
    onEditPrintColor,
    onPrintClipWarning,
    partHotspots,
    hasBackView,
    onToggleView,
    onResetDesign,
    saving,
    saveDisabled,
    onPrev,
    onNext,
    onSave,
    stripeDrawingsBySide,
    stripeDrawEditor,
    onSetStripeDrawEditor,
    onUpdateStripeDrawingsBySide,
    customCutsBySide,
    customCutEditor,
    onSetCustomCutEditor,
    onUpdateCustomCutsBySide,
    customCutZoneColors,
    onCustomCutRuntimeUpdate,
    onPreviewPaintCustomCutZone,
    highlightedPartKey,
    sparklePartKeys,
    sparkleToken,
    highlightedCustomCutZoneId,
    sparkleCustomCutZoneIds,
    sparkleCustomCutToken,
    step1PartsSectionProps,
    step2PartsSectionProps,
    finalStepProps,
    isFooterNavCollapsed,
    onToggleFooterCollapse,
}) => (
    <div className={isPageVariant ? styles.pageWrapper : styles.modalContent}>
        <div className={styles.designerFrame}>
            <DesignerHeaderSection
                variantError={variantError}
                onClose={onClose}
                isPageVariant={isPageVariant}
            />

            <div className={styles.gridGap16}>
                <Stepper steps={steps} currentStep={currentStep} />

                <div className={`${styles.pageDesignerGrid} ${currentStepKey === STEP.SUMMARY ? styles.pageDesignerGridSingle : ""}`}>
                    {currentStepKey !== STEP.SUMMARY && (
                    <>
                    <div
                        className={`${styles.pagePreviewColumn} ${
                            isPreviewCollapsed ? styles.pagePreviewColumnCollapsed : ""
                        }`}
                    >
                        <div className={styles.collapsibleBlock}>
                            <DesignerPreviewPanel
                                selectedParts={selectedPartsForPreview}
                                root={normalizedRoot}
                                view={viewSide}
                                selectedPrints={selectedPrints}
                                printDetails={printDetails}
                                allColors={allColors}
                                activePrintKey={activePrintKey}
                                onSelectPrint={onSelectPreviewPrint}
                                onTransformPrint={onTransformPrint}
                                onDeletePrint={onDeletePrint}
                                onEditPrintColor={onEditPrintColor}
                                onPrintClipWarning={onPrintClipWarning}
                                partHotspots={partHotspots}
                                onSelectPart={step1PartsSectionProps?.onPreviewPaintPart}
                                canFlip={hasBackView}
                                onToggleView={onToggleView}
                                onResetDesign={onResetDesign}
                                currentStep={currentStep}
                                currentStepKey={currentStepKey}
                                stripeColors={stripeColors}
                                totalSteps={steps.length}
                                saving={saving}
                                saveDisabled={saveDisabled}
                                onPrev={onPrev}
                                onNext={onNext}
                                onSave={onSave}
                                stripeDrawingsBySide={stripeDrawingsBySide}
                                stripeDrawEditor={stripeDrawEditor}
                                onSetStripeDrawEditor={onSetStripeDrawEditor}
                                onUpdateStripeDrawingsBySide={onUpdateStripeDrawingsBySide}
                                customCutsBySide={customCutsBySide}
                                customCutEditor={customCutEditor}
                                onSetCustomCutEditor={onSetCustomCutEditor}
                                onUpdateCustomCutsBySide={onUpdateCustomCutsBySide}
                                customCutZoneColors={customCutZoneColors}
                                onCustomCutRuntimeUpdate={onCustomCutRuntimeUpdate}
                                onPreviewPaintCustomCutZone={onPreviewPaintCustomCutZone}
                                highlightedPartKey={highlightedPartKey}
                                sparklePartKeys={sparklePartKeys}
                                sparkleToken={sparkleToken}
                                highlightedCustomCutZoneId={highlightedCustomCutZoneId}
                                sparkleCustomCutZoneIds={sparkleCustomCutZoneIds}
                                sparkleCustomCutToken={sparkleCustomCutToken}
                            />
                            <button
                                type="button"
                                className={`${styles.blockToggle} ${styles.previewColumnToggle}`}
                                onClick={onTogglePreviewCollapsed}
                                aria-label={isPreviewCollapsed ? "Expandir vista previa hacia abajo" : "Contraer vista previa hacia arriba"}
                                title={isPreviewCollapsed ? "Expandir vista previa hacia abajo" : "Contraer vista previa hacia arriba"}
                            >
                                <span className={styles.toggleArrow} aria-hidden="true">
                                    <svg
                                        viewBox="0 0 24 24"
                                        className={`${styles.toggleArrowIcon} ${isPreviewCollapsed ? styles.toggleArrowDown : styles.toggleArrowUp}`}
                                        fill="none"
                                    >
                                        <path d="M6 14l6-6 6 6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>
                    <button
                        type="button"
                        className={`${styles.previewDockToggle} ${
                            isPreviewCollapsed ? styles.previewDockToggleCollapsed : ""
                        }`}
                        onClick={onTogglePreviewCollapsed}
                        aria-label={isPreviewCollapsed ? "Abrir vista previa" : "Cerrar vista previa"}
                        title={isPreviewCollapsed ? "Abrir vista previa" : "Cerrar vista previa"}
                    >
                        <i
                            className={`bi ${
                                isPreviewCollapsed ? "bi-chevron-double-left" : "bi-chevron-double-right"
                            }`}
                            aria-hidden="true"
                        />
                    </button>
                    </>
                    )}
                    <div className={styles.pageControlsColumn}>
                        <div className={styles.pageStepScroll}>
                            <DesignerStepPanel
                                currentStepKey={currentStepKey}
                                variantStepProps={variantStepProps}
                                detailsStepProps={detailsStepProps}
                                stripesStepProps={stripesStepProps}
                                step1PartsSectionProps={step1PartsSectionProps}
                                step2PartsSectionProps={step2PartsSectionProps}
                                finalStepProps={finalStepProps}
                            />
                        </div>
                    </div>
                </div>
                <ExternalStepNav
                    isCollapsed={isFooterNavCollapsed}
                    onToggleCollapse={onToggleFooterCollapse}
                    currentStep={currentStep}
                    totalSteps={steps.length}
                    onPrev={onPrev}
                    onPrimary={currentStep < steps.length ? onNext : onSave}
                    primaryDisabled={currentStep < steps.length ? false : (saving || saveDisabled)}
                    primaryLabel={currentStep < steps.length ? "SIGUIENTE" : (saving ? "Guardando..." : "CONFIRMAR")}
                />
            </div>
        </div>
    </div>
);

export default DesignerMainLayout;
